(function() {
  'use strict';

  let currentIndex = 0;
  let lastCounterValue = 1;
  let totalImages = 0;
  let thumbnails = [];
  let mediaData = [];
  let syncInterval = null;
  let observer = null;
  let filmstripContainer = null;

  const container = document.getElementById('pdp-dots-container');
  if (!container) return;

  // Get thumbnail URL with proper sizing
  function getThumbnailUrl(src) {
    if (src.includes('width=')) {
      return src.replace(/width=\d+/, 'width=128');
    }
    return src + (src.includes('?') ? '&' : '?') + 'width=128';
  }

  // Load media data from JSON script
  function loadMediaData() {
    const dataScript = document.getElementById('pdp-media-data');
    if (dataScript) {
      try {
        mediaData = JSON.parse(dataScript.textContent);
        return mediaData.length;
      } catch (e) {
        console.warn('Error parsing media data:', e);
      }
    }
    
    // Fallback: detect from slides
    const slides = document.querySelectorAll('.slideshow__slide');
    const validSlides = Array.from(slides).filter(slide => {
      const hasImage = slide.querySelector('img');
      const hasVideo = slide.querySelector('deferred-media, [class*="deferred-media"]');
      const hasContent = slide.innerHTML.trim().length > 50;
      return (hasImage || hasVideo) && hasContent;
    });
    
    // Generate basic media data from slides
    mediaData = validSlides.map((slide, index) => {
      const img = slide.querySelector('img');
      return {
        id: slide.dataset.mediaId || `media-${index}`,
        src: img ? getThumbnailUrl(img.src) : '',
        alt: img ? img.alt : `Product image ${index + 1}`,
        type: slide.querySelector('deferred-media, [class*="deferred-media"]') ? 'video' : 'image'
      };
    });
    
    return mediaData.length;
  }

  // Fast gallery detection
  function isGalleryReady() {
    const slides = document.querySelectorAll('.slideshow__slide');
    const counter = document.querySelector('.pagination__count .slider-counter--current');
    return slides.length > 0 && counter;
  }

// Navigate to specific slide
function navigateToSlide(index) {
  const mediaGallery = document.querySelector('media-gallery');
  const mediaItem = mediaData[index];
  
  if (mediaGallery && mediaItem) {
    // Immediately set the counter to prevent sync delays
    const counterEl = document.querySelector('.pagination__count .slider-counter--current');
    if (counterEl) {
      counterEl.textContent = (index + 1).toString();
      lastCounterValue = index + 1;
    }
    
    // Update thumbnail immediately
    updateActiveThumbnail(index);
    
    // Navigate gallery
    mediaGallery.changeImage(mediaItem.id);
  }
}

  // Build thumbnail filmstrip
  function buildThumbnailStrip() {
    totalImages = loadMediaData();
    
    // Get total from container data attribute as fallback
    if (totalImages === 0) {
      const containerTotal = container.getAttribute('data-total-images');
      totalImages = containerTotal ? parseInt(containerTotal) : 0;
    }
    
    if (totalImages === 0 || totalImages === 1) {
      container.style.display = 'none';
      return false;
    }
    
    // Create filmstrip container
    filmstripContainer = document.createElement('div');
    filmstripContainer.className = 'filmstrip-wrapper';
    filmstripContainer.setAttribute('role', 'tablist');
    filmstripContainer.setAttribute('aria-label', `Product gallery: ${totalImages} images`);
    
    thumbnails = [];
    
    // Create thumbnails
    for (let i = 0; i < totalImages; i++) {
      const mediaItem = mediaData[i];
      if (!mediaItem) continue;
      
      const thumbnailItem = document.createElement('div');
      thumbnailItem.className = `filmstrip-item ${i === 0 ? 'active' : ''}`;
      thumbnailItem.setAttribute('data-index', i.toString());
      thumbnailItem.setAttribute('data-type', mediaItem.type);
      thumbnailItem.setAttribute('role', 'tab');
      thumbnailItem.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      thumbnailItem.setAttribute('tabindex', i === 0 ? '0' : '-1');
      
      const img = document.createElement('img');
      img.src = mediaItem.src;
      img.alt = mediaItem.alt || `View ${i + 1}`;
      img.loading = 'lazy';
      
      thumbnailItem.appendChild(img);
      
      // Add click handler
      thumbnailItem.addEventListener('click', () => {
        navigateToSlide(i);
      });
      
      // Add keyboard handler
      thumbnailItem.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          navigateToSlide(i);
        }
      });
      
      thumbnails.push(thumbnailItem);
      filmstripContainer.appendChild(thumbnailItem);
    }
    
    // Create spacer element
    const spacer = document.createElement('div');
    spacer.style.cssText = `
      width: 48px; 
      height: 72px; 
      min-width: 48px; 
      background: rgba(255, 255, 255, 0.1);
      flex-shrink: 0;
      border: 0.25px solid rgba(0, 0, 0, 0.1);
      border-radius: 1px;
    `;
    filmstripContainer.appendChild(spacer);
    
    container.innerHTML = '';
    container.appendChild(filmstripContainer);
    container.style.visibility = 'visible';
    
    return true;
  }

  // Update active thumbnail and scroll position
  function updateActiveThumbnail(newIndex) {
    if (newIndex < 0 || newIndex >= thumbnails.length) return;
    
    currentIndex = newIndex;
    
    // Update active states
    thumbnails.forEach((thumbnail, i) => {
      const isActive = i === newIndex;
      thumbnail.classList.toggle('active', isActive);
      thumbnail.setAttribute('aria-selected', isActive ? 'true' : 'false');
      thumbnail.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    
    // Auto-scroll active thumbnail into view
    const activeThumbnail = thumbnails[newIndex];
    if (activeThumbnail && filmstripContainer) {
      activeThumbnail.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }

// Establish sync with slideshow - throttled for smoothness
function establishSync() {
  const counterEl = document.querySelector('.pagination__count .slider-counter--current');
  if (!counterEl) return;

  let isThrottled = false;

  // MutationObserver with throttling instead of debouncing
  observer = new MutationObserver(() => {
    if (isThrottled) return; // Skip if we just updated
    
    const newValue = parseInt(counterEl.textContent || '1');
    if (newValue !== lastCounterValue && newValue >= 1 && newValue <= totalImages) {
      lastCounterValue = newValue;
      updateActiveThumbnail(newValue - 1);
      
      // Throttle for 100ms to prevent rapid-fire updates
      isThrottled = true;
      setTimeout(() => {
        isThrottled = false;
      }, 100);
    }
  });
  
  observer.observe(counterEl, { 
    childList: true, 
    characterData: true, 
    subtree: true 
  });
}

// Initialize
function init() {
  if (isGalleryReady()) {
    if (buildThumbnailStrip()) {
      establishSync();
      updateActiveThumbnail(0);
    }
  } else {
    // Quick retry if not ready
    setTimeout(init, 50);
  }
}

  // Start immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();